var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es293.js.map
